module.exports = __webpack_public_path__ + "static/media/builtinv2-Height.a5a180b7.svg";